import { Component, Inject, OnInit, Optional } from '@angular/core';
import { ControlContainer, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseFpxFormComponent } from '@fpx/core';
import { ProcessShellService } from 'src/app/process-shell/services/process-shell.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CBXDialogData } from 'src/app/fpx-core/services/dialog/dialog.service';
import { CommonService } from 'src/app/common.service';

@Component({
  selector: 'app-error-alert',
  templateUrl: './error-alert.component.html',
  styleUrls: ['./error-alert.component.scss'],
  providers: [
  ]
})
export class ErrorAlertComponent {
  mode:any=this.commonService.getApplicationMode();

  constructor(
    @Optional() controlContainer: ControlContainer,
    formBuilder: FormBuilder,
    private _router: Router,
    private dialogRef: MatDialogRef<ErrorAlertComponent>,
    public commonService:CommonService,
    @Inject(MAT_DIALOG_DATA) protected data: CBXDialogData
  ) {
  }

  close() {
    this.dialogRef.close();
  }
  redirect(){
    this.dialogRef.close(1);
  }

}
